/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice } from "@reduxjs/toolkit";

import { RequestStatus } from "~/constants";
import { getActiveNewsAsync } from "~/features/news/thunks";
import { NewsState } from "~/features/news/types";

const initialState: NewsState = {
  meta: {
    initStatus: RequestStatus.IDLE,
  },
  data: {
    activeNews: null,
  },
};

const newsSlice = createSlice({
  name: "newsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActiveNewsAsync.pending, (state) => {
        state.meta.initStatus = RequestStatus.PENDING;
      })

      .addCase(getActiveNewsAsync.fulfilled, (state, action) => {
        state.meta.initStatus = RequestStatus.SUCCESS;
        state.data.activeNews = action.payload;
      })

      .addCase(getActiveNewsAsync.rejected, (state) => {
        state.meta.initStatus = RequestStatus.ERROR;
      });
  },
});

export const NewsActions = newsSlice.actions;
export const NewsReducer = newsSlice.reducer;
